// extracted by mini-css-extract-plugin
export var chevronIcon = "_dl-2";
export var teamName = "_dl-1";
export var teamSwitcherButton = "_dl-0";